module.exports = __webpack_public_path__ + "static/media/direct-value-widget.e822ca30.svg";